var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3101 9.39581C11.5034 9.197 11.5034 8.87466 11.3101 8.67585L7.35051 4.60312C7.25769 4.50765 7.1318 4.45401 7.00053 4.45401C6.86926 4.45401 6.74337 4.50765 6.65055 4.60312L2.69095 8.67585C2.49766 8.87466 2.49766 9.197 2.69095 9.39581C2.88424 9.59462 3.19763 9.59462 3.39092 9.39581L7.00053 5.68307L10.6101 9.39581C10.8034 9.59462 11.1168 9.59462 11.3101 9.39581Z",
    fill: "#0C0C0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.ce3ee03406622f31461e096d5027ee45.svg";
export { ForwardRef as ReactComponent };